import Vue from 'vue'
import Router from 'vue-router'
import app from '../services/app'

import childRouter from '../../../../src/router'

import MainLayout from '../components/Templates/Layouts/MainLayout'
import MinimalLayout from '../components/Templates/Layouts/MinimalLayout'

import Login from '../components/Contents/Minimal/Login.vue'
import Logout from '../components/Contents/Minimal/Logout.vue'

Vue.use(Router)

export default {
  get (store) {
    return new Router({
      linkActiveClass: '',
      routes: [
        {
          path: '/session',
          component: MinimalLayout,
          children: [
            {
              path: 'login',
              component: Login
            },
            {
              path: 'logout',
              component: Logout
            }
          ]
        },
        {
          path: '/',
          component: MainLayout,
          beforeEnter: (to, from, next) => {
            return app.beforeEnterRoute(store, to, from, next)
          },
          children: childRouter.routes()
        },
        {
          path: '*',
          redirect: '/'
        }
      ]
    })
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/router/index.js